import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { List } from './List'
import { GlossaryProps } from './types'

export const Glossary: FC<GlossaryProps> = ({ seo, content, header, footer }) => {
  const { breadcrumb, title, subtitle, description, search_input_label, glossary } = content

  return (
    <Page seo={seo} header={header} footer={footer}>
      <Featured breadcrumb={breadcrumb} title={title} subtitle={subtitle} description={description} />
      <List search_input_label={search_input_label} glossary={glossary} />
    </Page>
  )
}
